import { render, staticRenderFns } from "./FunctionBox.vue?vue&type=template&id=4e2431ec&"
import script from "./FunctionBox.vue?vue&type=script&lang=js&"
export * from "./FunctionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports